import { automationRouteNames } from '@/routes/constants/location'
const depreciatedFeatures = [
    {
      name: "Campaigns",
      routes: [automationRouteNames.campaigns, "customer_acquisition"],
      enable: false,
    },
    {
      name: "Triggers",
      routes: [automationRouteNames.triggers, "triggers"],
      enable: false,
    },
]

export default depreciatedFeatures;
